<template>
  <div>
    <template v-if="topHashtags.length">
      <div class="mb-3 d-flex justify-space-between">
        <div>
          <b>{{ keyMap.hashtags.title }}:</b>

          <span
            v-for="(item, index) in topHashtags.slice(0, 5)"
            :key="'hashtag-' + index"
          >
            #{{ item.value }} ({{ item.count }})
          </span>
        </div>
        <v-btn text small color="primary" @click="showDialog('hashtags')">
          More Details
          <v-icon right>expand_more</v-icon>
        </v-btn>
      </div>

      <v-divider></v-divider>
    </template>


    <template v-if="topMentions.length">
      <div class="my-3 d-flex justify-space-between">
        <div>
          <b>{{ keyMap.mentions.title }}:</b>

          <span
            v-for="(item, index) in topMentions.slice(0, 5)"
            :key="'mention-' + index"
          >
            @{{ item.value }} ({{ item.count }})
          </span>
        </div>
        <v-btn text small color="primary" @click="showDialog('mentions')">
          More Details
          <v-icon right>expand_more</v-icon>
        </v-btn>
      </div>

      <v-divider></v-divider>
    </template>

    <template v-if="topSponsors.length">
      <div class="my-3 d-flex justify-space-between">
        <div>
          <b>{{ keyMap.sponsors.title }}:</b>

          <span
            v-for="(item, index) in topSponsors.slice(0, 5)"
            :key="'sponsor-' + index"
          >
            @{{ item.value }} ({{ item.count }})
          </span>
        </div>
        <v-btn text small color="primary" @click="showDialog('sponsors')">
          More Details
          <v-icon right>expand_more</v-icon>
        </v-btn>
      </div>

      <v-divider></v-divider>
    </template>

    <v-dialog
      v-model="shouldShowDialog"
      max-width="960"
      scrollable
    >
      <v-card>
        <v-card-title class="px-10">
          {{ selectedKeywordType ? keyMap[selectedKeywordType].title : "" }}
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <v-data-table
            :headers="tableHeaders"
            :items="tableItems"
            hide-default-footer
            disable-pagination
          ></v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text color="primary" @click="shouldShowDialog = false">Okay</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "TopKeywords",

  props: {
    moduleId: {
      type: [Symbol, String, Number],
      required: true
    }
  },

  data: () => ({
    selectedKeywordType: null,
    shouldShowDialog: false,

    keyMap: {
      hashtags: {
        getter: "topHashtags",
        title: "Top Hashtags",
      },
      mentions: {
        getter: "topMentions",
        title: "Top Mentions",
      },
      sponsors: {
        getter: "topSponsors",
        title: "Top Sponsors"
      }
    },

    tableHeaders: [
      {
        text: "Tag",
        value: "tag"
      },
      {
        text: "Posts",
        value: "posts"
      },
      {
        text: "Likes",
        value: "likes"
      },
      {
        text: "Users",
        value: "users"
      },
      {
        text: "Followers",
        value: "followers"
      },
    ],
  }),

  computed: {
    // Fetch the API response data from VUEX getters
    topHashtags() {
      return this.$store.getters["paidCollaborations/topHashtags"](this.moduleId)
    },

    topMentions() {
      return this.$store.getters["paidCollaborations/topMentions"](this.moduleId)
    },

    topSponsors() {
      return this.$store.getters["paidCollaborations/topSponsors"](this.moduleId)
    },

    tableItems() {
      // if none of them has been selected, return empty array
      return !this.selectedKeywordType ? [] :
        // if either of them has been selected, find their getter
        this[ this.keyMap[this.selectedKeywordType].getter ]
          // then loop through it to modify the way we want it
          .map((item) => {
            return {
              tag: item.value,
              posts: item.count,
              likes: item.likes,
              users: item.accounts,
              followers: item.followers
            }
          })
    }
  },

  methods: {
    showDialog(type) {
      this.selectedKeywordType = type
      this.shouldShowDialog = true
    }
  }
}
</script>
